var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center flex-column pa-4 rounded-xl mt-10"},[_c('v-card',{attrs:{"flat":"","width":"40%"}},[_c('UserModal',{attrs:{"is-updating-existing-user":true,"data-information-prop":_vm.dataInformations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }